export default __webpack_public_path__ + "static/media/November2012.02acc4f5.png";